import {
    API
} from '../Api.class';

export class InventoryStatsAPI extends API {

    constructor(baseUrl) {
        super(baseUrl)

    }


    async countByInterestCategories(meta) {
        this.loading = true

        return await this.__axiosInstance.get('api/v1/inventory/stats/count-by-interest-categories', {
            meta,
        })
    }


}